import { useRef, useEffect, useCallback } from 'react';

interface UseAbortController {
  getAbortSignal: () => AbortSignal;
}

function useAbortController(): UseAbortController {
  const controllerRef = useRef<AbortController | null>(null);

  useEffect(() => {
    return () => controllerRef.current?.abort();
  }, []);

  const getAbortSignal = useCallback((): AbortSignal => {
    controllerRef.current?.abort();
    controllerRef.current = new AbortController();
    return controllerRef.current.signal;
  }, []);

  return { getAbortSignal };
}

export default useAbortController;
